import styled from 'styled-components';

import Banner from '@ovpn/ui/banner';
import { color } from '@ovpn/ui/tokens';

import { media } from '../../utils';

export const NotificationBanner = styled(Banner)`
    width: 100%;
    margin: var(--spacing-md);
    ${media.SM`
        margin: var(--spacing-md) var(--spacing-sm);
    `}
    ${media.XS`
        margin: var(--spacing-md) var(--spacing-xs);
    `}
    margin-bottom: 0 !important;

    .ovpn-banner-container {
        justify-content: center;
    }
`;

export const Message = styled.span`
    a {
        color: ${color.brand.blue};
        text-decoration: underline;

        &:hover,
        &:active {
            color: #264e8d;
        }
    }

    p {
        margin: 0;
    }
`;
